import React from "react";
import {useTranslation} from "react-i18next";
import {Box, Container, Divider, Paper, Stack, Tab, Tabs} from "@mui/material";
import InfoProfile from "../../components/profile/InfoProfile";
import Correction from "../../components/profile/Correction";
import Annotation from "../../components/profile/Annotation/Annotation";
import {Redirect, Route, Switch, useHistory, useParams} from "react-router-dom";
import {makeRequest} from "../../services/requestService";
import {API_URL} from "../../constants";

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

export default function Profile() {
    const {tab} = useParams();
    const history = useHistory();
    const {t} = useTranslation('common');
    const [value, setValue] = React.useState(0);
    const [userInfos, setUserInfos] = React.useState();
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (!loading)
            return;
        let timeoutId;
        makeRequest(`${API_URL}/user/info`).then((response) => {
            if (response.status === 200) {
                setUserInfos(response.data);
                timeoutId = window.setTimeout(() => {
                    setLoading(false);
                }, 200);
            }
        });
        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [loading]);

    React.useEffect(() => {
        document.title = t("main.title") + " - " + t("main.pages.profile.title");
    }, [t]);

    React.useEffect(() => {
        switch (tab) {
            case "annotation":
                setValue(1);
                break;
            case "correction":
                setValue(2);
                break;
            default:
                setValue(0);
        }
    }, [tab]);

    const handleChange = (event, newValue) => {
        switch (newValue) {
            case 1:
                history.replace("/profile/annotation");
                break;
            case 2:
                history.replace("/profile/correction");
                break;
            default:
                history.replace("/profile/info");
        }
    };

    return (
        <Container sx={{flexGrow: 1, display: "flex", p: 2}}>
            <Paper elevation={0} sx={{flexGrow: 1, p: 1}}>
                <Stack height="100%">
                    <Box display="flex" justifyContent="center">
                        <Tabs
                            orientation="horizontal"
                            variant="scrollable"
                            value={value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            onChange={handleChange}
                        >
                            <Tab label={t("main.pages.profile.tab.profile")} {...a11yProps(0)}/>
                            <Tab label={"Annotation"} {...a11yProps(1)}/>
                            <Tab label={t("main.pages.profile.tab.correction")}  {...a11yProps(2)} />
                        </Tabs>
                    </Box>
                    <Divider orientation={"horizontal"}/>
                    <Box mt={2} flexGrow={1} display="flex">
                        <Switch>
                            <Route exact path="/profile/info"><InfoProfile user={userInfos}/></Route>
                            <Route exact path="/profile/annotation"><Annotation/></Route>
                            <Route exact path="/profile/correction"><Correction/></Route>
                            <Route exact path="/profile/*"><Redirect to="/profile/info"/></Route>
                        </Switch>
                    </Box>
                </Stack>
            </Paper>
        </Container>
    );
}